module.exports = __webpack_public_path__ + "img/yoga.b6ce0387.png";